import { render, staticRenderFns } from "./UnauthorizedModal.vue?vue&type=template&id=db53f142&scoped=true&"
import script from "./UnauthorizedModal.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedModal.vue?vue&type=script&lang=js&"
import style0 from "./UnauthorizedModal.vue?vue&type=style&index=0&id=db53f142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db53f142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db53f142')) {
      api.createRecord('db53f142', component.options)
    } else {
      api.reload('db53f142', component.options)
    }
    module.hot.accept("./UnauthorizedModal.vue?vue&type=template&id=db53f142&scoped=true&", function () {
      api.rerender('db53f142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/UnauthorizedModal.vue"
export default component.exports